// ============= RE-EXPORTS FROM CENTRALIZED PORT CONFIGURATION =============
// These exports maintain backward compatibility with existing code.
// For new code, import directly from '@/app/config/ports'

export {
  // Types
  type TLocalizeVersion,
  type TPortConfig,
  type TPortDisplayConfig,
  type TSupportedPort,
  type TPortLocation,
  type TMapCenter,
  type TPolygonCoordinates,
  type TGlobalConfig,
  // Constants
  LOCALIZE_VERSION,
  PORTS,
  GLOBAL_CONFIG,
  NEAR_PORT_DISTANCE_KM,
  SUPPORTED_PORTS,
  // Helper functions
  getPortConfig,
  getPortByUnlocode,
  getPortBySlug,
  getLocalizeVersionFromSlug,
  getUnlocodeForVersion,
  getDefaultPort,
  getAllPortKeys,
  getPortByDomainLock,
  getPortDisplayConfig
} from './config/ports'

// ============= APPLICATION CONSTANTS =============

export const MAPBOX_STYLE_URL = 'mapbox://styles/teqplay/cmfmofe8o00ar01qybcvf04u0'

export const LOGIN_URL = '/auth/login'
export const REGISTER_URL = `${LOGIN_URL}?screen_hint=signup`

export const SUPPORTED_LANGUAGES = ['en', 'pt'] as const

export const BASE_HOSTS_TEQPLAY = [
  'teqplay.com',
  'portcallone-teqplaycom.vercel.app',
  'oneportcall.com'
]

export const SENTRY_URL =
  'https://2c2c8f241324761433a7833a9da2f5e7@o126205.ingest.us.sentry.io/4510024042807296'

export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? ''

// ============= STORAGE KEYS =============

export const STORAGE_KEY = {
  QUERY: 'QUERY',
  SKIP_REMOVE_CONFIRM: 'SKIP_REMOVE_CONFIRM',
  SKIP_DELETE_NOTE_CONFIRM: 'SKIP_DELETE_NOTE_CONFIRM',
  CLOSE_BANNER_SUPPORTED_PORTS: 'CLOSE_BANNER_SUPPORTED_PORTS',
  SELECTED_LOCALIZE_VERSION: 'SELECTED_LOCALIZE_VERSION',
  IS_OLD_USER: 'IS_OLD_USER',
  ACTIVE_TOP_TAB: 'ACTIVE_TOP_TAB',
  ACTIVE_PORT_SUB_TAB: 'ACTIVE_PORT_SUB_TAB',
  HAS_INITIALIZED_TAB: 'HAS_INITIALIZED_TAB',
  COMMUNITY_UPDATES_VESSEL_EVENT: 'COMMUNITY_UPDATES_VESSEL_EVENT',
  COMMUNITY_UPDATES_VESSEL_EVENT_APPLIED_MAP: 'COMMUNITY_UPDATES_VESSEL_EVENT_APPLIED_MAP',
  QUESTIONNAIRE_1_COMPLETE: 'QUESTIONNAIRE_1_COMPLETE'
} as const

export const SESSION_STORAGE_KEY = {
  QUESTIONNAIRE_1: 'QUESTIONNAIRE_1',
  QUESTIONNAIRE_1_SKIP: 'QUESTIONNAIRE_1_SKIP'
} as const

export const SESSION_KEY = {
  CONFIRM_MIGRATE_BOOKMARKS: 'CONFIRM_MIGRATE_BOOKMARKS',
  VESSEL_SCROLL_POSITION: 'VESSEL_SCROLL_POSITION'
} as const

export const QUERY_PARAMS = {
  NEW_NOTIFICATION: 'newNotification',
  SHARE: 'share',
  FOLLOWED: 'followed',
  CONTRIBUTE: 'contribute',
  LINEUP: 'lineup',
  LINEUPID: 'lineup_id'
} as const

export type TQueryParam = (typeof QUERY_PARAMS)[keyof typeof QUERY_PARAMS]

// ============= ONBOARD QUESTIONNAIRE =============

export const ON_BOARD_QUESTIONNAIRE = {
  ROLE: [
    'SHIP_OWNER_OPERATOR',
    'CHARTERER_TRADER',
    'BROKER_AGENT',
    'PORT_TERMINAL_REPRESENTATIVE',
    'MARITIME_SERVICE_PROVIDER',
    'LOGISTICS_SUPPLY_CHAIN',
    'JOURNALIST_MEDIA',
    'OTHER'
  ],
  LOOK_FOR_INFORMATION: [
    'VESSEL_ARRIVAL_DEPARTURE',
    'HISTORICAL_PORT_CALLS',
    'CURRENT_VESSEL_POSITION',
    'DELAY_WAITING_TIME',
    'PORT_CONGESTION',
    'VESSEL_PERFORMANCE_PATTERNS',
    'VERIFICATION_TIMESTAMPS',
    'GENERAL_VESSEL_LOOKUP',
    'JUST_BROWSING'
  ]
} as const

export type TQuestionnaireRole = (typeof ON_BOARD_QUESTIONNAIRE.ROLE)[number]
export type TQuestionnaireLookForInformation =
  (typeof ON_BOARD_QUESTIONNAIRE.LOOK_FOR_INFORMATION)[number]
